<script setup>
const props = defineProps(['text', 'color', 'textcolor']);
const { t } = useI18n();

const isVisible = ref(true);
const close = () => {
  isVisible.value = false;
};
</script>

<template>
  <div class="local-warning" :class="{ 'is-visible': isVisible }" role="alert" aria-label="Local warning alert" :style="{ backgroundColor: color, color: textcolor }">
    <div class="local-warning__text" v-html="text"></div>
    <button class="local-warning__close" :aria-label="t('global.local-warning-close-aria-label')" @click="close" @keyup.enter="close">
      <span class="icon-cross" @click="close" @keyup.enter="close" />
      <span class="hidden">{{ t('global.close-button') }}</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.local-warning {
  margin-bottom: -45px;
  margin-top: -45px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  padding-right: 50px;
  background: $black;
  color: $white;
  z-index: 11;
  transform: translateY(-200px);
  transition: transform 0.2s;
  line-height: 1.3;
  position: relative;
  @include mq($lg) {
    // position: absolute;
    // height: 55px;
    // margin-bottom: 0;
    // padding-right: 80px;
    // text-align: center;
  }

  &.is-visible {
    transform: none;
    transition-duration: 1000ms;
    margin-bottom: 55px;
    margin-top: 0;
  }

  &__text {
    a {
      @include underline-transition-reverse(1px);
    }
  }

  &__close {
    @include button-reset;
    position: absolute;
    top: 50%;
    right: 20px;
    padding: 5px;
    transform: translateY(-50%);
    cursor: pointer;
  }
}
</style>
